import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Logo } from "@/components/site/Header";
import { useAuth } from "@/lib/auth";
import { errDetail } from "@/lib/api";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  if (user) return <Navigate to="/admin/ingresos" replace />;

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await login(email, password);
      nav("/admin/ingresos");
    } catch (err) {
      const d = errDetail(err);
      setError(d === "generic" ? "No se pudo iniciar sesión" : d);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#0B192C]">
      <div className="hidden lg:block relative">
        <img src="/images/y-aerial.jpg" alt="" className="absolute inset-0 h-full w-full object-cover opacity-70" />
      </div>
      <div className="flex flex-col justify-center px-6 sm:px-16 py-16">
        <Logo />
        <h1 className="mt-14 font-display text-4xl text-white">Panel de administración</h1>
        <p className="mt-3 text-sm text-white/60">Gestiona yates, calendario, reservas y tours.</p>
        <form onSubmit={submit} className="mt-10 space-y-5 max-w-sm" data-testid="admin-login-form">
          <div className="space-y-1.5"><Label htmlFor="ad-email" className="text-white/80">Correo</Label>
            <Input id="ad-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-login-email-input" className="bg-white" /></div>
          <div className="space-y-1.5"><Label htmlFor="ad-pass" className="text-white/80">Contraseña</Label>
            <Input id="ad-pass" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-login-password-input" className="bg-white" /></div>
          {error && <p data-testid="admin-login-error" className="text-sm text-red-300">{error}</p>}
          <button type="submit" disabled={loading} data-testid="admin-login-submit-btn"
            className="w-full inline-flex items-center justify-center gap-2 rounded-lg bg-[#D4AF37] py-3.5 text-sm font-semibold text-[#0B192C] transition-colors hover:bg-[#F3E5AB] disabled:opacity-60">
            {loading && <Loader2 className="h-4 w-4 animate-spin" />}Entrar
          </button>
        </form>
      </div>
    </div>
  );
}
